var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGatIconId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8254_3239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.136 7.05469H25.4105C25.7433 7.05469 26.0625 7.1869 26.2978 7.42224C26.5331 7.65758 26.6654 7.97676 26.6654 8.30959V29.6429C26.6654 29.9757 26.5331 30.295 26.2978 30.5303C26.0625 30.7656 25.7433 30.8978 25.4105 30.8978H6.58693C6.25411 30.8978 5.93492 30.7656 5.69958 30.5303C5.46425 30.295 5.33203 29.9757 5.33203 29.6429V8.30959C5.33203 7.97676 5.46425 7.65758 5.69958 7.42224C5.93492 7.1869 6.25411 7.05469 6.58693 7.05469H12.8614",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1378 8.93712C19.1378 9.10353 19.0717 9.26313 18.9541 9.38079C18.8364 9.49846 18.6767 9.56457 18.5103 9.56457H13.4907C13.3243 9.56457 13.1647 9.49846 13.0471 9.38079C12.9294 9.26313 12.8633 9.10353 12.8633 8.93712V5.17241C12.8633 4.34036 13.1938 3.54238 13.7821 2.95403C14.3705 2.36569 15.1685 2.03516 16.0005 2.03516C16.8325 2.03516 17.6305 2.36569 18.219 2.95403C18.8073 3.54238 19.1378 4.34036 19.1378 5.17241V8.93712Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0837 29.7999V28.0746C23.0837 27.1595 22.7202 26.2818 22.073 25.6347C21.4259 24.9876 20.5483 24.624 19.6331 24.624H12.7319C11.8167 24.624 10.939 24.9876 10.2919 25.6347C9.6448 26.2818 9.28125 27.1595 9.28125 28.0746V29.7999",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1811 21.1734C18.0868 21.1734 19.6317 19.6286 19.6317 17.7228C19.6317 15.8171 18.0868 14.2722 16.1811 14.2722C14.2754 14.2722 12.7305 15.8171 12.7305 17.7228C12.7305 19.6286 14.2754 21.1734 16.1811 21.1734Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8254_3239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.466553)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatIconId);
export default __webpack_public_path__ + "static/media/gat-icon-id.5d70e1d281e6373426afbbb2e3204621.svg";
export { ForwardRef as ReactComponent };